import React from "react";
import { Link } from "react-router-dom";
import { Users, GaugeCircle, Fuel, ArrowRight } from "lucide-react";
import { mediaUrl, isAvailableNow } from "../lib/api";

export const SpecBadge = ({ icon: Icon, label }) => (
  <span className="inline-flex items-center gap-1.5 text-xs text-white/70 bg-[#151515] px-2.5 py-1 rounded-sm">
    <Icon size={13} className="text-[#B58A50]" /> {label}
  </span>
);

export const VehicleCard = ({ car, index = 0 }) => {
  return (
    <div
      className="card-kame group overflow-hidden flex flex-col hover:border-[#B58A50] transition-colors duration-200 animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`vehicle-card-${car.id}`}
    >
      <Link to={`/vuz/${car.slug || car.id}`} className="relative overflow-hidden bg-[#0a0a0a] aspect-[16/10] block" data-testid={`vehicle-image-link-${car.id}`}>
        <img
          src={mediaUrl(car.image_url)}
          alt={car.name}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 bg-black/70 text-[#B58A50] text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm border border-[#B58A50]/40">
          {isAvailableNow(car) ? "Dostupné" : "Nedostupné"}
        </span>
        {car.price_tiers && car.price_tiers.length > 0 && (
          <span className="absolute top-3 right-3 bg-[#B58A50] text-black text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm font-semibold">
            Sleva za delší pronájem
          </span>
        )}
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <Link to={`/vuz/${car.slug || car.id}`} className="font-display text-xl text-white uppercase tracking-wide hover:text-[#B58A50] transition-colors">{car.name}</Link>
        <p className="text-white/50 text-sm mt-1">
          {[car.engine, car.power_kw ? `${car.power_kw} kW` : null, car.transmission, car.fuel, car.year ? `r. ${car.year}` : null].filter(Boolean).join(" | ")}
        </p>

        <div className="flex flex-wrap gap-2 mt-4">
          {car.seats > 0 && <SpecBadge icon={Users} label={`${car.seats} míst`} />}
          {car.transmission && <SpecBadge icon={GaugeCircle} label={car.transmission} />}
          {car.fuel && <SpecBadge icon={Fuel} label={car.fuel} />}
        </div>

        <div className="mt-5 pt-4 border-t border-[#1c1c1c] mt-auto">
          <div className="flex items-baseline gap-2 flex-wrap">
            <span className="text-white/50 text-xs uppercase tracking-wider">od</span>
            <span className="font-display text-2xl text-[#B58A50] whitespace-nowrap leading-none">
              {car.price_per_day.toLocaleString("cs-CZ")} Kč
              <span className="text-white/50 text-xs font-sans font-normal"> / den</span>
            </span>
            <span className="text-white/35 text-[11px]">bez DPH</span>
          </div>
          <div className="flex gap-2 mt-4">
            <Link
              to={`/vuz/${car.slug || car.id}`}
              className="btn-outline-gold text-xs py-2.5 px-3 flex-1"
              data-testid={`vehicle-detail-${car.id}`}
            >
              Detail
            </Link>
            <Link
              to={`/rezervace?car=${car.id}`}
              className="btn-gold text-xs py-2.5 px-3 flex-1"
              data-testid={`vehicle-reserve-${car.id}`}
            >
              Rezervovat <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleCard;
